import React from 'react';

const Expand = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      {...props}
    >
      <path
        d='M8.46 4.335L10.875 1.92V3.9375C10.875 4.08668 10.9343 4.22976 11.0397 4.33525C11.1452 4.44073 11.2883 4.5 11.4375 4.5C11.5867 4.5 11.7298 4.44073 11.8352 4.33525C11.9407 4.22976 12 4.08668 12 3.9375V0.5625C12 0.413316 11.9407 0.270241 11.8352 0.164752C11.7298 0.0592632 11.5867 0 11.4375 0H8.0625C7.91331 3.14382e-09 7.77024 0.0592632 7.66475 0.164752C7.55926 0.270241 7.5 0.413316 7.5 0.5625C7.5 0.711684 7.55926 0.854758 7.66475 0.960247C7.77024 1.06574 7.91331 1.125 8.0625 1.125H10.08L7.665 3.54L8.0666 4.48588L8.46 4.335ZM0 11.4375V8.0625C3.14382e-09 7.91331 0.0592631 7.77024 0.164752 7.66475C0.270241 7.55926 0.413315 7.5 0.5625 7.5C0.711684 7.5 0.854758 7.55926 0.960247 7.66475C1.06574 7.77024 1.125 7.91331 1.125 8.0625V10.08L7.665 3.54L8.0666 4.48588L8.46 4.335L1.92 10.875H3.9375C4.08668 10.875 4.22976 10.9343 4.33525 11.0397C4.44073 11.1452 4.5 11.2883 4.5 11.4375C4.5 11.5867 4.44073 11.7298 4.33525 11.8352C4.22976 11.9407 4.08668 12 3.9375 12H0.5625C0.488548 12.0003 0.415269 11.9859 0.346889 11.9578C0.278509 11.9296 0.216381 11.8882 0.164089 11.8359C0.111797 11.7836 0.0703744 11.7215 0.0422115 11.6531C0.0140486 11.5847 -0.000297597 11.5114 0 11.4375Z'
        fill='black'
      />
    </svg>
  );
};

export default Expand;
